import { createEffect, createSignal, Show } from "solid-js";
import { goBack, pushPage, HubbleRoute } from "../../shared_states/modal";
import { Spacer } from "../../widgets/spacer";
import { BackButton, ButtonRegular } from "../../widgets/button";
import { createJob } from "~/utils/job";
import { PhoneOtpVerificationModal } from "./phone_otp_verification_modal";
import { initiatePhoneUpdate } from "~/data/products";
import { NumberKeyboard } from "../voucher_edit/number_keyboard";

export function PhoneCollectionModal(props: { onPhoneVerified: () => void }) {
  const [phoneNumber, setPhoneNumber] = createSignal<string>("");
  const [errorMessage, setErrorMessage] = createSignal<string | undefined>("");
  const [isFieldActive, setIsFieldActive] = createSignal(false);

  const phoneUpdateJob = createJob({
    errorCallback: (error) => {
      setErrorMessage(error.message);
    },
    initialJob: async () => {
      if (phoneNumber().length !== 10) {
        throw new Error("Please enter a 10 digit phone number");
      }
      return initiatePhoneUpdate(phoneNumber());
    },
    successCallback: async (response) => {
      // Navigate to OTP verification screen
      pushPage(
        () => (
          <PhoneOtpVerificationModal
            phoneNumber={phoneNumber()}
            otpToken={response.otpToken}
            onPhoneVerified={props.onPhoneVerified}
          />
        ),
        { isModal: false },
        HubbleRoute.PHONE_OTP_VERIFICATION
      );
    },
  });

  let phoneInput: HTMLInputElement | undefined;
  createEffect(() => {
    phoneInput?.focus();
  });

  createEffect(() => {
    phoneNumber();
    setErrorMessage(undefined);
  });

  return (
    <div class="flex h-full flex-col">
      <div class="flex h-full  flex-col bg-baseTertiaryMedium p-5">
        <BackButton />
        <div class="mt-[40px]"></div>
        <div class="pb-[2px] text-h3 text-textDark">Your phone number</div>
        <div class="pb-[20px] text-normal text-textNormal">
          Gift card details will be sent to your WhatsApp too
        </div>
        <div class="flex flex-col">
          <div
            class={`h-[48px] rounded-xl border bg-white  px-[16px] py-[13px] transition-colors 
          ${!!errorMessage() || isFieldActive() ? "!border-2" : "!px-[17px] !py-[14px]"}`}
            classList={{
              "border-buttonDark": isFieldActive(),
              "border-dividerDark ": !isFieldActive(),
              "!border-accentError": !!errorMessage(),
            }}
          >
            <form
              class="text flex  text-bold text-textDark"
              onSubmit={(e) => {
                e.preventDefault();
                phoneUpdateJob.run();
              }}
            >
              <div class="flex flex-row ">
                <span class="text-textPrimary">{"+91"}</span>
                <Spacer width={8} />
                <div class="h-full w-[1px] bg-[#D9D9D9]"></div>
                <Spacer width={8} />
                <input
                  class="w-full flex-1 bg-transparent text-textDark placeholder:text-normal placeholder:text-textNormal"
                  ref={phoneInput}
                  placeholder=" 10 digits phone no."
                  value={phoneNumber()}
                  onInput={(e) => setPhoneNumber(e.currentTarget.value)}
                  type="tel"
                  maxlength={10}
                  onFocus={() => setIsFieldActive(true)}
                  onBlur={() => setIsFieldActive(false)}
                />
              </div>
            </form>
          </div>
          <Show when={errorMessage()}>
            <Spacer height={4} />
            <span class="text-medium text-errorDark">{errorMessage()}</span>
          </Show>
        </div>
        <Spacer height={16} />
        <div class="grow"></div>
        <ButtonRegular
          onClick={() => phoneUpdateJob.run()}
          isLoading={phoneUpdateJob.isRunning()}
          isEnabled={true}
          class="button-filled mt-5"
        >
          Continue
        </ButtonRegular>
      </div>
      <div class="bg-[#CCCED3C2] p-[6px] pb-[20px]">
        <NumberKeyboard
          class="!my-0"
          onChange={(e) => {
            setPhoneNumber(e?.toString() ?? "");
          }}
        />
      </div>
    </div>
  );
}
